import baseRoute from '../baseRoute';

export default `${baseRoute}/reportType` as const;
